import React from "react"

import { Button, ButtonProps, Spinner } from "react-bootstrap"

interface ActionButtonProps extends ButtonProps {
  spin?: boolean
  disableOnSpin?: boolean
  children?: React.ReactNode
  icon: React.ReactNode
}

function ActionButtonWithIcon({
  spin = false,
  disableOnSpin = false,
  children = null,
  icon,
  className,
  disabled,
  ...buttonProps
}: ActionButtonProps) {
  const actualDisabled = disabled || (disableOnSpin && spin)
  const actualClassName = `${className || ""} d-flex align-items-center`

  return (
    <Button {...buttonProps} className={actualClassName} disabled={actualDisabled}>
      {!spin ? icon : <Spinner animation="border" size="sm" variant={buttonProps.variant} className="text-white" />}
      <span className="ml-1">{children}</span>
    </Button>
  )
}

export default ActionButtonWithIcon
